import { Middleware } from "@reduxjs/toolkit";
import { audiApi } from "./services/audi";
import { authApi } from "./services/auth";
import { bookingApi } from "./services/booking";
import { cinemaHallApi } from "./services/cinemahall";
import { contactApi } from "./services/contact";
import { miscApi } from "./services/misc";
import { movieApi } from "./services/movie";
import { userAPI } from "./services/user";
import { foodBookingApi } from "./services/foodbooking";
import { whatsappApi } from "./services/whatsapp";

export const middleware: Middleware[] = [
  audiApi.middleware,
  authApi.middleware,
  bookingApi.middleware,
  cinemaHallApi.middleware,
  contactApi.middleware,
  miscApi.middleware,
  movieApi.middleware,
  userAPI.middleware,
  foodBookingApi.middleware,
  whatsappApi.middleware,
];
